<template>
  <div style="display:inline;">
    <v-dialog
      v-model="meldungShow"
      width="500"
    >
      <v-alert
        text
        :type="meldungType"
        class="white"
      >
        <h2 class="mb-3">{{ meldungTitle }}</h2>
        <div v-html="meldungText"></div>
      </v-alert>
    </v-dialog>
    <v-dialog
      v-model="showDialog"
      fullscreen scrollable
      style="overflow:hidden;"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="ma-0"
        >
          <v-icon>mdi-qrcode-scan</v-icon>
        </v-btn>
      </template>
      <v-card style="overflow:hidden;">
        <div
          v-show="!fullscreenActive"
          style="position:fixed;top:0px;left:0px;width:100%;height:100%;display:flex;justify-content:center;align-items:center;"
          class="primary"
        >
          <v-card style="width:500px;max-width:90%;">
            <div align="right">
              <v-btn
                @click="closeScanDialog()"
                text
              >x</v-btn>
            </div>
            <div class="pa-3">
              <p>
                Nach Klick auf "Scan starten" können die QR-Codes auf den Karten eingescannt werden.<br/>
                <b>Achtung:</b> Der Scan kann durch Drücken der "esc"-Taste bzw. "Zurück" geschlossen werden.
              </p>
              <p>
                Welche Website soll im Hintergrund angezeigt werden?
              </p>
              <v-text-field
                label="Adresse (z.B. meine-website.de/dashboard)"
                v-model="settings.urlDashboard"
                @change="updateSettings()"
              />
              <v-checkbox
                label="Auf der Website kann geklickt werden"
                v-model="settings.iframeKlickbar"
                @change="updateSettings()"
              />
              <v-checkbox
                label="automatisches Aktualisieren aktivieren"
                v-model="settings.reload"
                @change="updateSettings()"
              />
              <v-text-field
                v-if="settings.reload"
                type="number"
                label="Aktualisieren alle ... Sekunden"
                v-model="settings.reloadSeconds"
                @change="updateSettings()"
              />
              <div align="center">
                <v-btn
                  @click="toggleFullScreen()"
                >Scan starten</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <!--<div v-if="isLoading">
          <v-progress-linear
            indeterminate
          ></v-progress-linear>
        </div>-->
        <v-dialog v-model="isLoading" width="500">
          <v-progress-linear
            indeterminate
          ></v-progress-linear>
        </v-dialog>
        <div
          v-if="(isLoadingIframe && fullscreenActive)"
          style="
            position:fixed;z-index:1;
            top:0px;left:0px;width:100vw;height:100vh;
            border:none;
            background-color:rgba(0,0,0,0.8);color:#fff;"
        >
          <div class="loadingSpinner"></div>
        </div>
        <iframe
          id="200-scanAPI-iframe"
          v-if="fullscreenActive"
          :src="settings.urlDashboard"
          :style="`width:100vw;height:100vh;pointer-events:${settings.iframeKlickbar ? 'auto' : 'none'};border:none;`"
          class="black"
          @load="loadIframe();"
        ></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
  },
  data: () => ({
    settings: {
      urlDashboard: '',
      reload: false,
      reloadSeconds: 300,
      iframeKlickbar: false,
    },
    intervalAutoReload: null,
    showDialog: false,
    fullscreenActive: false,
    eventListenerKeyUpSet: false,
    scannedValue: '',
    meldungShow: false,
    meldungTitle: '',
    meldungText: '',
    meldungType: '',
    isLoading: false,
    isLoadingIframe: false,
  }),
  computed: {
    //
  },
  watch: {
    showDialog(neu, alt) {
      if (!neu) {
        document.getElementById('app').style.cursor = 'default';
      }
    }
  },
  methods: {
    closeScanDialog() {
      this.$emit('closeDialog', {
        hideLoadingAnimation: false,
        type: 'loaddata',
        data: {},
      });
      this.showDialog = false;
      //window.location.reload();
    },
    updateSettings() {
      if (this.settings.urlDashboard.substring(0, 8) !== 'https://') {
        if (this.settings.urlDashboard.substring(0, 7) === 'http://') {
          this.settings.urlDashboard = this.settings.urlDashboard.substring(7, this.settings.urlDashboard.length);
        }
        this.settings.urlDashboard = 'https://'+this.settings.urlDashboard;
      }
      console.log(this.settings.urlDashboard);
      localStorage.setItem('f200_scanApi_settings', JSON.stringify(this.settings));
    },
    checkFullscreen() {
      /*if (!document.fullscreenElement) {
        return false;
      }
      return true;*/
      if (!this.fullscreenActive) {
        return false;
      }
      return true;
    },
    loadIframe() {
      setTimeout(() => {
        this.isLoadingIframe = false;
      }, 500);
    },
    toggleFullScreen() {
      /*if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }*/
      if (this.fullscreenActive) {
        this.isLoadingIframe = false;
        this.fullscreenActive = false;
        document.getElementById('app').style.cursor = 'default';
        clearInterval(this.intervalAutoReload);
      } else {
        this.isLoadingIframe = true;
        this.fullscreenActive = true;
        if (!this.settings.iframeKlickbar) {
          document.getElementById('app').style.cursor = 'none';
        }
        if (this.settings.reload) {
          this.intervalAutoReload = setInterval(() => {
            this.isLoadingIframe = true;
            document.getElementById('200-scanAPI-iframe').src = document.getElementById('200-scanAPI-iframe').src
          }, this.settings.reloadSeconds * 1000);
        }
      }
    },
    showMeldung(meldung) {
      this.meldungTitle = meldung.title || '';
      this.meldungText = meldung.text || '';
      this.meldungType = meldung.type || 'success';
      this.meldungShow = true;
      setTimeout(() => {
        this.meldungShow = false;
      }, meldung.duration || 2500);
    },
    async trySaveSettings() {
      let value = this.scannedValue.split('-');
      let url = false;
      const body = new FormData();
      if (
        value[0] !== '200'
        || value.length !== 4
      ) {
        this.showMeldung({
          title: 'Ungültiger QR-Code!',
          text: '',
          type: 'error',
        });
      } else {
        if (
          value[2] === '1'
        ) {
          url = '200/200/?func=getSettings';
          body.append('code', this.$store.state.login.session.code);
          body.append('dataToSave', JSON.stringify({
            dataToSave: {
              type: 'anwesenheitsstatus',
              data: {
                id_kind: parseInt(value[1], 10),
              },
            },
          }));
        }
      }
      this.scannedValue = '';
      if (url) {
        // SENDEN
          this.isLoading = true;
          await fetch(`${process.env.VUE_APP_API_HOST}/${url}`, {
            method: 'POST',
            body,
          })
            .then((response) => response.json())
            .then((res) => {
              this.showMeldung(res.meldung);
              this.isLoading = false;
            })
            .catch((error) => {
              console.error(error);
              this.showMeldung({
                title: 'Es ist ein Fehler aufgetreten',
                text: 'Bitte erneut versuchen...',
                type: 'error',
              });
              this.isLoading = false;
            });
        //
      }
    },
  },
  mounted() {
    this.fullscreenActive = this.checkFullscreen();
    if (!this.eventListenerKeyUpSet) {
      if (localStorage.getItem('f200_scanApi_settings')) {
        this.settings = JSON.parse(localStorage.getItem('f200_scanApi_settings'));
      }
      window.addEventListener("fullscreenchange", (event) => {
        this.fullscreenActive = this.checkFullscreen();
      });
      window.addEventListener("keyup", (event) => {
        event.preventDefault();
        if (
          this.showDialog
          && this.fullscreenActive
          && !this.meldungShow
        ) {
          if (event.key.length === 1) {
            this.scannedValue += event.key;
          } else if (event.key === 'Enter') {
            this.trySaveSettings();
          } else if (event.key === 'Escape' && this.checkFullscreen()) {
            //this.toggleFullScreen();
          } else {
            //console.log(event.key);
          }
        }
      });
    }
    this.eventListenerKeyUpSet = true;
    if (Object.keys(this.$route.query).includes('SCAN')) {
      this.showDialog = true;
      this.toggleFullScreen();
    }
    /*setTimeout(() => {
      console.log(JSON.stringify(this.$route.query));
    }, 1000);*/
  },
};
</script>

<style>
  .loadingSpinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(0deg);
  }

  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }
</style>